export default __webpack_public_path__ + "static/dockercompose-logo-7132aa843bdedef842150a49752fcc3a.webp";